// 大运会顶部菜单

module.exports = {
  sportType: 'compreSportsMeet',
  menuData: [
    {
      name: 'webMenu',
      arr: [
        // {
        //   name: '赛程',
        //   key: 'schedule',
        //   routeName: 'CSMeetScheduleIndex_WUSG',
        //   act: true,
        // },
        {
          name: '赛程',
          key: 'schedule',
          routeName: 'CSMeetScheduleIndex_WUSG',
          act: true,
          child: [
            {
              name: '常规赛程',
              key: 'regularSchedule',
              routeName: 'CSMeetRegularScheduleIndex_WUSG',
              act: false,
            },
            {
              name: '运动员赛程',
              key: 'playersSchedule',
              act: false,
              routeName: 'CSMeetEventPlayersScheduleIndex_WUSG',
            },
          ],
        },
        {
          name: '项目',
          key: 'bigSports',
          routeName: 'CSMeetBigSportsIndex_WUSG',
          act: false,
        },
        {
          name: '奖牌',
          key: 'medal',
          routeName: 'CSMeetMedalIndex_WUSG',
          act: false,
          child: [
            {
              name: '奖牌榜',
              key: 'medalTally',
              routeName: 'CSMeetMedalTallyIndex_WUSG',
              act: false,
            },
            {
              name: '奖牌明细',
              key: 'medalDetailList',
              act: false,
              routeName: 'CSMeetMedalDetailListIndex_WUSG',
            },
          ],
        },
        {
          name: '代表团',
          key: 'delegation',
          routeName: 'CSMeetDelegationIndex_WUSG',
          act: false,
        },
        {
          name: '运动员',
          key: 'player',
          routeName: 'CSMeetPlayerIndex_WUSG',
          act: false,
        },
        {
          name: '纪录',
          key: 'record',
          routeName: 'CSMeetRecordIndex_WUSG',
          act: false,
        },
        {
          name: '场馆',
          key: 'venue',
          routeName: 'CSMeetVenueIndex_WUSG',
          act: false,
        },
      ],
    },
    {
      name: 'openMenu',
      arr: [
        {
          name: '节目单',
          key: 'programList',
          routeName: 'CSMeetProgramListIndex_WUSG',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '播出单',
          key: 'broadcastList',
          routeName: 'CSMeetBroadcastListIndex_WUSG',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '数据包装',
          key: 'dataPackagList',
          routeName: 'CSMeetDataPackagListIndex_WUSG',
          act: false,
          isOpenWeb: true,
        },
      ],
    },
  ],
}
